var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconPremiumDropdown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.648,
    height: 7.239,
    viewBox: "0 0 11.648 7.239",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M21479.248,109.656l4.41,4.411,4.41-4.411",
    transform: "translate(-21477.834 -108.241)",
    fill: "none",
    stroke: "#1b246a",
    strokeLinecap: "round",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPremiumDropdown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-premium-dropdown.821b5446.svg";
export { ForwardRef as ReactComponent };